// Wellness 페이지 디자인 시스템
import { COLORS } from '../../constants/colors';

// 이미지 리소스 - 메인 캐릭터 이미지 (즉시 필요, lazy loading 없음)
import chickenImage from '../../assets/svg/Wellness-kko.svg';
import chickenImage2 from '../../assets/img/Wellness-kko2.png'; // TODO: WEBP 변환 후 .webp로 변경
import chickenImage3 from '../../assets/svg/Wellness-kko3.svg';
import chickenImage4 from '../../assets/svg/Wellness-kko4.svg';
import chickenImage5 from '../../assets/img/wellness-kko5.png'; // TODO: WEBP 변환 후 .webp로 변경

import pulsbuttonImage from '../../assets/img/pulsbutton.png';
import plusIcon from '../../assets/img/plus.png';

// 친구 아바타용 wellness 이미지들 - 동적 import로 변경 (조건부 사용)
// wellness-1~6.png는 친구가 있을 때만 필요하므로 동적 로딩

// 캐릭터 이미지 매핑 (내부 사용)
const WELLNESS_IMAGES = {
    default: chickenImage,      // 기본 상태
    alarm: chickenImage2,       // 알람 켜진 상태
    friends: chickenImage3,     // 친구 있는 상태
    studying: chickenImage4,    // 몰두잇 상태
    rest: chickenImage5         // 휴식 상태
};

// 친구 아바타 옵션 - 동적 import 함수로 변경
// 🚀 이미지 최적화: PNG → WEBP 변환 (WEBP 파일 생성 후 경로 변경 필요)
export const getAvatarImage = async (index) => {
    // TODO: WEBP 변환 후 .webp로 변경
    const avatarModules = [
        () => import('../../assets/img/wellness-1.png'),
        () => import('../../assets/img/wellness-2.png'),
        () => import('../../assets/img/wellness-3.png'),
        () => import('../../assets/img/wellness-4.png'),
        () => import('../../assets/img/wellness-5.png'),
        () => import('../../assets/img/wellness-6.png'),
    ];
    
    if (index >= 0 && index < avatarModules.length) {
        try {
            const module = await avatarModules[index]();
            return module.default;
        } catch (error) {
            console.error('아바타 이미지 로드 실패:', error);
            // fallback
            const fallbackModule = await avatarModules[0]();
            return fallbackModule.default;
        }
    }
    // fallback
    const fallbackModule = await avatarModules[0]();
    return fallbackModule.default;
};

// 기존 AVATAR_OPTIONS 호환성을 위한 동기 버전 (초기 로딩 방지용 - 빈 배열)
export const AVATAR_OPTIONS = [];

// 플러스 아이콘
export const PLUS_ICON = pulsbuttonImage;
export const PLUS_ICON_SMALL = plusIcon;

// 배경 그라데이션 스타일 (내부 사용)
const BACKGROUND_STYLES = {
    default: '',
    alarm: 'linear-gradient(180deg, #FFFFFF 0%, #F0FFF4 100%)',    // 연한 연두색
    friends: 'linear-gradient(180deg, #FFFFFF 0%, #FFE4D6 100%)',  // 연한 살구색
    studying: 'linear-gradient(180deg, #FFFFFF 0%, #FFE4D6 100%)', // 연한 살구색
    rest: 'linear-gradient(180deg, #FFFFFF 0%, #D3D3D3 100%)'      // 연한 검은색 그라데이션
};

// 메시지 상태별 텍스트 (내부 사용)
const WELLNESS_MESSAGES = {
    default: {
        line1: "<span style='font-family: \"LaundryGothic\", sans-serif;'>나를 깨워줄 친구가</span>",
        line2: "<strong>아직 없어요</strong>"
    },
    alarm: {
        line1: "<span style='font-family: \"LaundryGothic\", sans-serif;'>좋아요!</span>",
        line2: "<strong>잘 쉬고 있어요</strong>"
    },
    friends: (count) => ({
        line1: "<span style='font-family: \"LaundryGothic\", sans-serif;'>와우!</span>",
        line2: `<strong>${count}명의 친구가 있어요! </strong>`
    }),
    studying: {
        line1: "<strong>몰두잇</strong>에서",
        line2: "<span style='font-family: \"LaundryGothic\", sans-serif;'>열심히 달리고 있어요🔥</span>"
    },
    rest: {
        line1: "<strong>휴식</strong>이 필요해요..",
        line2: ""
    }
};

// 팝업 스타일
export const POPUP_STYLES = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },
    content: {
        width: '300px',
        background: '#fff',
        padding: '20px',
        borderRadius: '12px'
    },
    title: {
        fontSize: '22px',
        marginBottom: '10px',
        fontFamily: 'Pretendard'
    },
    userCode: {
        textAlign: 'center',
        fontSize: '16px',
        color: COLORS.KKOKKIO_PRIMARY,
        marginBottom: '20px',
        padding: '12px',
        backgroundColor: '#FBF5F5',
        borderRadius: '18px',
        fontFamily: 'Pretendard'
    },
    input: {
        border: 'none',
        borderBottom: `2px solid ${COLORS.KKOKKIO_PRIMARY}`,
        outline: 'none',
        padding: '5px 0',
        fontSize: '16px',
        fontWeight: 'normal',
        color: '#000',
        fontFamily: 'Pretendard',
        width: '100%',
        boxSizing: 'border-box',
        letterSpacing: '-1px'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '20px'
    }
};

// 유틸리티 함수
export const getWellnessImage = (hasAlarm, hasFriends, isStudying, isRest) => {
    // 일반 상태별 이미지
    if (isRest) return WELLNESS_IMAGES.rest;
    if (isStudying) return WELLNESS_IMAGES.studying;
    if (hasAlarm) return WELLNESS_IMAGES.alarm;
    if (hasFriends) return WELLNESS_IMAGES.friends;
    return WELLNESS_IMAGES.default;
};

export const getBackgroundStyle = (hasAlarm, hasFriends, isStudying, isRest) => {
    if (isRest) return BACKGROUND_STYLES.rest;
    if (isStudying) return BACKGROUND_STYLES.studying;
    if (hasAlarm) return BACKGROUND_STYLES.alarm;
    if (hasFriends) return BACKGROUND_STYLES.friends;
    return BACKGROUND_STYLES.default;
};

export const getWellnessMessage = (hasAlarm, hasFriends, friendCount, friendStatus, tokenUserID, isStudying, isRest, shouldLog = false) => {
    if (isRest) return WELLNESS_MESSAGES.rest;
    if (isStudying) return WELLNESS_MESSAGES.studying;
    if (hasAlarm) return WELLNESS_MESSAGES.alarm;
    if (hasFriends) return WELLNESS_MESSAGES.friends(friendCount);
    return WELLNESS_MESSAGES.default;
};

export const getMessageClassName = (hasAlarm, hasFriends, isStudying, isRest) => {
    if (isRest) return 'rest-active';
    if (isStudying) return 'studying-active';
    if (hasAlarm) return 'alarm-active';
    if (hasFriends) return 'friends-active';
    return 'default-state';
};